import { isHtmlContent, sanitizeFormsHtml } from "../../lib/formsRichText";

/**
 * Renders Forms Library long-form instructional text (template
 * description, intro_text, a text_block field's help_text) that may be
 * either legacy plain text (rendered exactly as before — line breaks and
 * blank lines preserved via whitespace-pre-wrap, zero visual change) or
 * real HTML authored through FormsRichTextEditor (sanitised then
 * rendered with a small, constrained prose style).
 */
export function RichTextDisplay({ content, className = "", testId }) {
  if (!content) return null;
  if (isHtmlContent(content)) {
    return (
      <div
        className={`prose prose-sm max-w-none text-sm prose-p:my-1.5 prose-headings:font-display prose-headings:font-semibold prose-headings:my-2 prose-ul:my-1.5 prose-ol:my-1.5 ${className}`}
        data-testid={testId}
        dangerouslySetInnerHTML={{ __html: sanitizeFormsHtml(content) }}
      />
    );
  }
  return (
    <div className={`whitespace-pre-wrap text-sm ${className}`} data-testid={testId}>
      {content}
    </div>
  );
}
